import React from 'react';
import { Toast } from '@dbk/ui-notifications'

/* Toast message with a heading and description part to display errors/warnings
Included this file under trading/common since it is used only for trading module for now
If needed for other modules in future need to be moved under components/common
This Toast message occupies entire screen width
*/
const getToastViews = (props) => {
  const { onClose, toastMsgs } = props;
  return toastMsgs.map((toastMsg, index) => {
    const messages = toastMsg.message && Array.isArray(toastMsg.message) ? toastMsg.message.map(msg => (
      <p>{msg.errorDesc}</p>
    )) : toastMsg.message;
    return (
      <Toast actionTestID="btn_trade_toast_close_test" accessibilityLabel="btn_trade_toast_close_test" underline status={toastMsg.type} onClose={() => onClose(toastMsg, index)}>
        <div className="heading-container" testID={"trade_toast_header_test"} accessibilityLabel={"trade_toast_header_test"}>{toastMsg.header}</div>
        <div className="message-container" testID={"trade_toast_message_test"} accessibilityLabel={"trade_toast_message_test"}>{messages}</div>
      </Toast>
    )
  })
}

const ToastFullLength = (props) => {
  const { onClose, toastMsgs } = props;
  if (toastMsgs && Array.isArray(toastMsgs) && toastMsgs.length > 0) {
    return getToastViews(props)
  }
  return <div/>
}

export default ToastFullLength;
